module.exports = __webpack_public_path__ + "img/upload.20af258a.svg";